import React, { memo, useMemo, Suspense, lazy } from "react";
import { CSSTransition, TransitionGroup } from "react-transition-group";
import { useAuth } from "../../Lib/Hooks";
import SplashLoader from "../ui/SplashLoader";
import { useLocation } from "react-router-dom";
import App from "../../App";
const PublicLayoutV2 = lazy(() => import("./AuthLayout"));
const AuthLayout = lazy(() => import("./ProtectedLayout"));

const Layout = () => {
  const { pathname } = useLocation();
  const { session, authenticated } = useAuth();

  const AppLayout = useMemo(() => {
    if (!authenticated) {
      return PublicLayoutV2;
    }
    return AuthLayout;
  }, [authenticated]);

  const isV2 =
    pathname.startsWith("/v2") ||
    pathname === "/dashboard" ||
    pathname.startsWith("/users") ||
    pathname === "/manage-document";

  if (isV2) {
    return (
      <Suspense fallback={<SplashLoader />}>
        <App />
      </Suspense>
    );
  }

  return (
    <Suspense fallback={<SplashLoader />}>
      <TransitionGroup>
        <CSSTransition key={pathname} classNames="fade" timeout={300}>
          <AppLayout />
        </CSSTransition>
      </TransitionGroup>
    </Suspense>
  );
};

export default memo(Layout);
